/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.styl';
// import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */

import { RichText } from '@wordpress/block-editor';
import { BlockLabel } from '../_common/BlockLabel';
import { title } from './block.json';
import { StyleInspector, SelectBgClassControl } from '../_common/InspectorSelect';
import classnames from 'classnames';

import '../_common/underline'

export default function Edit({ attributes, setAttributes }) {
	const { textContent, blockStyleClass } = attributes;

	let props = useBlockProps()
	props.className=classnames(props.className,blockStyleClass)

	return (
		<div {...props}>
			<BlockLabel name={title} />
			<StyleInspector>
				<SelectBgClassControl
					value={blockStyleClass}
					onChange={(val) => {
						setAttributes({ blockStyleClass: val });
					}}
				/>
			</StyleInspector>
			<div className={classnames(['ParagraphBlock', blockStyleClass])}>
				<RichText
					tagName="p"
					allowedFormats={['core/bold','create-block/underline','core/link']}
					value={textContent}
					onChange={(newContent) => {
						setAttributes({ textContent: newContent });
					}}
					placeholder="(テキストを入力...)"
				/>
			</div>
		</div>
	);
}
